"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var options = [
    'more-vertical',
    'edit-outline',
    'trash-can-outline',
    'machines-outline',
    'settings-outline',
    'alert-fill',
    'visibility-off-outline',
    'account-outline',
    'alert-circle-outline',
    'alert-octagon-outline',
    'alert-outline',
    'arrow-bottom-left',
    'arrow-bottom-right',
    'arrow-down',
    'arrow-left',
    'arrow-right',
    'arrow-top-left',
    'arrow-top-right',
    'arrow-up',
    'chart-box-outline',
    'check',
    'chevron-double-down',
    'chevron-double-left',
    'chevron-double-right',
    'chevron-double-up',
    'chevron-down',
    'chevron-left',
    'chevron-right',
    'chevron-up-down',
    'chevron-up',
    'close',
    'dashboard-outline',
    'log-out',
    'map-outline',
    'menu',
    'minus',
    'plus',
    'question-circle-outline',
    'search-outline',
    'account-team-outline',
    'visibility-on-outline',
];
exports.default = options;
